// Super-admin: only this account can promote/demote admins and is hidden from
// Team list and from task assignee/notify pickers.
export const SUPER_ADMIN_EMAIL = "info@hisocialitalia.it";

// Accounts hidden from everyone (Team list + task assignee/notify pickers):
// the super-admin and the legacy demo admin.
export const HIDDEN_USER_EMAILS = ["info@hisocialitalia.it", "admin@taskpulse.app"];

export function isHiddenUser(user) {
  const email = ((user && user.email) || "").toLowerCase();
  return HIDDEN_USER_EMAILS.includes(email);
}

// Special "client" used to group tasks in the Amministrazione section.
// Not shown as a normal client on the Dashboard.
export const ADMIN_SECTION_CLIENT_ID = "admin-section";

export function isSuperAdmin(user) {
  if (!user || !user.email) return false;
  return user.email.toLowerCase() === SUPER_ADMIN_EMAIL;
}

export function isCliente(user) {
  return !!user && user.role === "cliente";
}

// Paths a cliente is allowed to access
export const CLIENTE_ALLOWED_PATHS = ["/il-mio-lavoro"];
